export enum MediaType {
  VIRTUAL_TOUR = 'tour',
  VIDEO = 'video',
  PHOTO = 'photo',
  MARKETING_GRAPHIC = 'marketing_graphic',
  INFOGRAPHIC = 'infographic',
  ICON = 'icon',
  ALL_MEDIA = 'all_media',
}
